import { useEffect } from "react"
// @ts-ignore
import EZUIKit from "ezuikit-js";

import './index.css'

// 全屏云台，对讲,电子放大
const serial = 'F97415409'
const accessToken= 'ra.dnsfc9kb86jf4lpo4ytodzzu9841efcr-3d4csq0fgm-0zbxrp5-yqehsi26v'
// let player = null;
export default function CameraPlayer(props:any) {
  useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    const id = query.get('id');
    console.log('id', id);
  })
  useEffect(()=>{
    new EZUIKit.EZUIKitPlayer({
      id: 'rn-camera-player',
      autoplay: true,
      url: `ezopen://open.ys7.com/${serial}/1.hd.live`,
      accessToken,
      width: 375,
      height: 200,
      themeData: {
        autoFocus: 5,
        poster:
          "https://resource.eziot.com/group1/M00/00/89/CtwQEmLl8r-AZU7wAAETKlvgerU237.png",
        header: {
          color: "#1890ff",
          activeColor: "#FFFFFF",
          backgroundColor: "#000000",
          btnList: [],
        },
        footer: {
          color: "#FFFFFF",
          activeColor: "#1890FF",
          backgroundColor: "#00000021",
          btnList: [
            {
              iconId: "play",
              part: "left",
              defaultActive: 1,
              memo: "播放",
              isrender: 1,
            },
            {
              "iconId": "pantile",
              "part": "left",
              "defaultActive": 0,
              "memo": "云台控制按钮",
              "isrender": 1
          },
            // {
            //   iconId: "capturePicture",
            //   part: "left",
            //   defaultActive: 0,
            //   memo: "截屏按钮",
            //   isrender: 1,
            // },
            {
              iconId: "sound",
              part: "left",
              // defaultActive: this.show.sound ? 1 : 0,
              memo: "声音按钮",
              // isrender: this.show.sound ? 1 : 0,
            },

            {
              iconId: "zoom",
              part: "left",
              defaultActive: 0,
              memo: "电子放大",
              isrender: 1,
            },
            {
              iconId: "expend",
              part: "right",
              defaultActive: 0,
              memo: "全局全屏按钮",
              isrender: 1,
            },
          ],
        },
      },
    })
  },[])
  return (
    <div className="wrapper">
      <div id="rn-camera-player"></div>
    </div>
  )
}